import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL + "/admin/quick-boost",
 headers: {
 "Content-Type": "application/json",
 },
});

api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) {
 config.headers.Authorization = `Bearer ${token}`;
 } else {
 }
 return config;
});

export const fetchAllQuickBoosts = async (params) => {
 try {
 const res = await api.get("", { params });
 return { status: res.status, data: res.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Failed to fetch",
 };
 }
};

export const fetchQuickBoostById = async (id) => {
 try {
 const res = await api.get(`/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Failed to fetch",
 };
 }
};

export const createQuickBoost = async (data) => {
 try {
 const res = await api.post("", data);
 return { status: res.status, data: res.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Create failed",
 };
 }
};

export const updateQuickBoost = async (id, data) => {
 try {
 const res = await api.put(`/${id}`, data);
 return { status: res.status, data: res.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Update failed",
 };
 }
};

export const deleteQuickBoost = async (id) => {
 try {
 const res = await api.delete(`/${id}`);
 return { status: res.status };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Delete failed",
 };
 }
};
